const VISITOR_STORAGE_KEY = 'frog-access-visitor-v1';

export const resolveVisitorId = () => {
  if (typeof window === 'undefined') return 'anonymous';

  const stored = window.localStorage.getItem(VISITOR_STORAGE_KEY);
  if (stored) return stored;

  const generated =
    window.crypto?.randomUUID?.() || `visitor-${Date.now()}-${Math.random().toString(16).slice(2)}`;
  window.localStorage.setItem(VISITOR_STORAGE_KEY, generated);
  return generated;
};

export const resolveDevice = () => {
  if (typeof navigator === 'undefined') return 'desconhecido';
  const userAgent = navigator.userAgent.toLowerCase();
  if (/ipad|tablet/.test(userAgent)) return 'tablet';
  if (/mobi|android|iphone/.test(userAgent)) return 'mobile';
  return 'desktop';
};

export const resolveBrowser = () => {
  if (typeof navigator === 'undefined') return 'desconhecido';
  const userAgent = navigator.userAgent;
  if (userAgent.includes('Edg/')) return 'Edge';
  if (userAgent.includes('Chrome/')) return 'Chrome';
  if (userAgent.includes('Firefox/')) return 'Firefox';
  if (userAgent.includes('Safari/') && !userAgent.includes('Chrome/')) return 'Safari';
  return 'Outro';
};
